<template>
  <the-table-page :titleTable="$t('Элементы перечисления')"
                  :tableData="tableData"
                  :load="load"
                  fieldId="codeEnumId"
                  :updateData="updateData"
                  :fieldInfoList="fieldInfoList"
                  :searchStart="searchStart"
                  :sortData="sortData"
                  :setSort="setSort"
                  :deleteEl="deleteEl"  
                  :prefixEdit="prefixEdit?prefixEdit:`/code/${$route.params.CodeId}/CodeEnum`"
                  :prefixShow="prefixShow?prefixShow:`/code/${$route.params.CodeId}/CodeEnum`"
                  :linkCreate="linkCreate?linkCreate:`/code/${$route.params.CodeId}/CodeEnum/create`"
                  configName = "codeEnum"
                  :roleName="nameRoleEntity"
  ></the-table-page>
</template>
<script>

  import TheTablePage from "../../../TheTablePage.vue";
  import {CODE_ENUM} from "../store/type";

  import {
    SET_MAIN_PAGINATION,
    SET_MAIN_PAGINATION_PER_PAGE,
    SET_MAIN_PAGINATION_PAGE,
    SET_MAIN_SORT_ENTITY,
    SET_MAIN_SEARCH_ENTITY
  } from "../../../../../src/store/type"

  import {READ, DELETE} from '../../../../store/type'
  import {mapState} from 'vuex';
  import NotificationSample from 'src/pages/Dashboard/Components/NotificationSample';
  import {DEFAULT_PER_PAGE, TYPE_ERRORS, FIELD_LANG_CODE_ENUM, GET_MEMORY_PER_PAGE} from '../../../../constant'
  import notify from '../../../../helpers/notify/notify'
  import convertLangDataToTable from '../../../../helpers/converters/convertLangDataToTable'
  import {NAME_OBJECT} from "../../../../RoleConstanans"
  export default {
    name: "CodeEnum",
    props: {
      prefixEdit: {},
      prefixShow: {},
      linkCreate: {}
    },
    components: {
      TheTablePage
    },
    data() {
      return {
        load: false
      }
    },
    computed: {
      ...mapState({
        fieldInfoList: state => state.code.fieldCodeEnumList ,
        lang: state => state.common.lang,
        sortData: state => state.pagination.sortData,
      }),
      nameRoleEntity(){
        return NAME_OBJECT.codeEnum
      },
      tableData() {
          let langNow = this.$store.state.common.lang
          let dataNow = this.$store.state.code.codeEnum || []
          if (dataNow && dataNow.length > 0) {
            dataNow = convertLangDataToTable(dataNow, langNow, FIELD_LANG_CODE_ENUM)
            return dataNow
          }
      }
    },
    watch: {
      lang() {
        this.initData()
      }
    },
    methods: {
      getData() {
        this.load= true
        this.$store.dispatch(CODE_ENUM + READ, {self:this, CodeId: this.$route.params.CodeId }).then(res=>{
          this.load= false
        })
        .catch(err=>{
          this.load= false
          notify(this, this.$t('Ошибка получения данных'), TYPE_ERRORS.DANGER)
        })
      },
      updateData() {
        this.getData()
      },
      searchStart(search){
        this.$store.commit(SET_MAIN_SEARCH_ENTITY, search)
        this.getData()
      },
      setSort(val){
        this.$store.commit(SET_MAIN_SORT_ENTITY, val)
        this.getData()
      },
      deleteEl(id){
        this.$store.dispatch(CODE_ENUM + DELETE, {  CodeId: this.$route.params.CodeId,  CodeEnumId: id, self:this} ).then(res=>{
          this.getData();
             if(res.errors && res.errors.length  == 0){notify(this, this.$t("Успешно"),TYPE_ERRORS.SUCCESS); }
        })
      },
      initData() {
        this.$store.commit( CODE_ENUM + READ ,{ data: [], fieldInfoList: []})
        this.$store.commit( SET_MAIN_SORT_ENTITY,{})
        this.$store.commit( SET_MAIN_SEARCH_ENTITY, '')
        this.$store.commit( SET_MAIN_PAGINATION_PER_PAGE, GET_MEMORY_PER_PAGE())
        this.$store.commit( SET_MAIN_PAGINATION_PAGE, 1)
        this.getData()
      }
    },
    created() {
      this.initData()
    }
  }
</script>
